module.exports = __webpack_public_path__ + "img/01.7533a555.jpg";